module.exports = __webpack_public_path__ + "static/media/hot32.68f0732e.jpg";